import styled from "styled-components";
import { Font, Color, breakpoints } from "@/shared/Constants";

export const StoryMainContainerRecetas = styled.section.attrs((props) => ({
  className: props.className,
}))`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  row-gap: 25px;
  width: 100%;
  margin-top: 35px;

  ${breakpoints.phone} {
    flex-direction: column;
    margin-top: 25px;
  }
  .image-container {
    margin: 0 0 25px 0;
  }
  ${breakpoints.tablet} {
    max-width: 975px;
    column-gap: 0;
  }

  .recipes-ia-container {
    margin-top: -30px;
    ${breakpoints.phone} {
      margin-top: 0px;
    }
  }
  .columnContainer {
    column-gap: 1rem;
    display: flex;
    flex-direction: column;
    width: 300px;

    ${breakpoints.phone} {
      display: none;
    }
    .container {
      position: relative;
      padding-bottom: 1rem;
    }
    .sticky-element {
      position: sticky;
      top: 50px;
      height: 600px;
      margin: 2rem 0 0 0;
      width: 300px;

      ${breakpoints.tablet} {
        top: auto;
      }

      ${breakpoints.phone} {
        display: none;
      }
    }
    .column {
      width: 300px;
      ${breakpoints.tablet} {
        position: relative;
      }

      ${breakpoints.phone} {
        display: none;
      }
    }
  }
`;
